module.exports = __webpack_public_path__ + "26349ec6f6144313fe0c5753f90ae11c.svg";